import { defineStore } from "pinia";
import { Filter } from "./types";
import { Pagination } from "@/data/base_classes/pagination";

interface FilterValuesStore {
  filters: Record<
    string,
    {
      pagination: Pagination;
      filters: Filter[];
    }
  >;
}

export const useFilterPaginationStore = defineStore("filterPaginationStore", {
  state: (): FilterValuesStore => ({
    filters: {},
  }),
  actions: {
    set(
      key: string,
      value: {
        pagination: Pagination;
        filters: Filter[];
      },
    ): void {
      this.filters[key] = value;
    },
    get(key: string):
      | {
          pagination: Pagination;
          filters: Filter[];
        }
      | undefined {
      return this.filters[key];
    },
    clear(key: string): void {
      delete this.filters[key];
    },
  },
});
